module.exports = __webpack_public_path__ + "static/img/serverShop3.1cb17e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop3.png
// module id = Pnqk
// module chunks = 2